module.exports = __webpack_public_path__ + "static/media/aw_mobile_hero_350_mozza_en.6f67de47.jpg";